<template>
  <div>
    <logged-vars-list />
  </div>
</template>

<script>
import LoggedVarsList from '@/components/logging/LoggedVarsList';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';

export default {
  name: 'LoggedItemsListView',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Grafy / Logování',
        },
      ],
    };
  },
  components: { LoggedVarsList },
};
</script>

<style scoped>

</style>
